import * as React from 'react';
import { Field } from 'react-final-form';
import { AnyObject } from 'final-form';
import AnimateHeight from 'react-animate-height';

interface IFormToggleProps {
    name: string;
    items: Array<string>;
    allowBlank?: boolean;
    tabIndex?: number;
    style?: React.CSSProperties;
    disabled?: boolean;

    onChange?: (value: string) => void;
}

interface IFormToggleState {
    hasFocus: boolean;
    highlightedItem: string;
}

export default class FormToggle extends React.Component<IFormToggleProps, IFormToggleState> {
    constructor(props: IFormToggleProps) {
        super(props);

        this.state = {
            hasFocus: false,
            highlightedItem: undefined,
        };
    }

    click = (value: string, input: AnyObject) => {
        if (this.props.disabled) {
            return;
        }

        if (input.value === value && this.props.allowBlank) {
            input.onChange(undefined);
            if (this.props.onChange) {
                this.props.onChange(undefined);
            }
        } else {
            input.onChange(value);
            if (this.props.onChange) {
                this.props.onChange(value);
            }
        }
    };

    focusHandler = () => {
        this.setState({ hasFocus: true, highlightedItem: this.props.items[0] });
    };

    blurHandler = () => {
        this.setState({ hasFocus: false, highlightedItem: undefined });
    };

    keydownHandler = (e: React.KeyboardEvent<HTMLDivElement>, input: AnyObject) => {
        if (this.props.disabled) {
            return;
        }

        const currentIndex = this.props.items.indexOf(this.state.highlightedItem);

        if (e.key === 'ArrowLeft') {
            if (currentIndex > 0) {
                this.setState({ highlightedItem: this.props.items[currentIndex - 1] });
            }
        } else if (e.key === 'ArrowRight') {
            if (currentIndex < this.props.items.length - 1) {
                this.setState({ highlightedItem: this.props.items[currentIndex + 1] });
            }
        } else if (e.key === ' ') {
            if (input.value === this.props.items[currentIndex] && this.props.allowBlank) {
                input.onChange(undefined);
                if (this.props.onChange) {
                    this.props.onChange(undefined);
                }
            } else {
                input.onChange(this.props.items[currentIndex]);
                if (this.props.onChange) {
                    this.props.onChange(this.props.items[currentIndex]);
                }
            }
        }
    };

    render() {
        const actions = {
            onFocus: this.focusHandler,
            onBlur: this.blurHandler,
        };

        return (
            <Field name={this.props.name}>
                {({ input, meta }) => {
                    const hasError = meta.submitFailed && meta.error;
                    const errorHeight = hasError ? 'auto' : 0;

                    return (
                        <>
                            <div
                                className={`dlc-form-toggle ${this.props.disabled ? 'disabled' : ''}`}
                                style={this.props.style}
                                tabIndex={this.props.tabIndex || 0}
                                onKeyDown={
                                    this.state.hasFocus ? (e: React.KeyboardEvent<HTMLDivElement>) => this.keydownHandler(e, input) : undefined
                                }
                                {...actions}
                            >
                                {this.props.items.map((item: string, index: number) => {
                                    const selectClass = item === input.value ? 'selected' : '';
                                    const highlightClass = item === this.state.highlightedItem ? 'highlight' : '';

                                    return (
                                        <span className={selectClass} key={index} onClick={() => this.click(item, input)}>
                                            <span className={highlightClass}>{item}</span>
                                        </span>
                                    );
                                })}
                            </div>
                            <AnimateHeight height={errorHeight} duration={300}>
                                <div className="dlc-form-textbox-error" style={{ marginTop: '-1.5rem' }}>
                                    {meta.error}
                                </div>
                            </AnimateHeight>
                        </>
                    );
                }}
            </Field>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/forms/redesign/FormToggle.tsx